import React from "react";
import classnames from 'classnames';
import "./style.scss";

const FormField = ({label, children, up, clearField, isSelect}) => {
    const rootClassname = classnames('form-field', { '_up': up, '_select': isSelect });
    const fieldContainerClassname = classnames('form-field__field', { '_with_clear_button': !!clearField });
    return (
        <div className={rootClassname}>
            <div className="form-field__label">{label}</div>
            <div className={fieldContainerClassname}>
                {children}
            </div>
            {!!clearField && (
                <div className="form-field__buttons">
                    <div className="clear-button-container">
                        <button type="button" className="delete" onClick={clearField}></button>
                    </div>
                </div>
            )}
        </div>
    )
};

FormField.defaultProps = {

};

FormField.propTypes = {

};

export default FormField;